import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { AuthenticationService } from 'app/auth/service';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  /**
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   */
  constructor(private _router: Router, private authService: AuthenticationService) {}

  // canActivate
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let can = false;
    await this.authService.checkAuth().then((x) => (can = x));
    if (!can) {
      localStorage.setItem('routeBeforeLogin',state.url);
      this._router.navigateByUrl('/pages/login');
    }
    return can;
  }
}
